import React, { Component } from 'react';
import { Redirect, Route, NavLink, Link, Switch } from 'react-router-dom';
import superagent from 'superagent';
import ReactLoading from 'react-loading';
import queryString from 'query-string';


class ConfirmAccount extends Component {
    constructor(props) {
        super(props);

        this.onClickVerify = this.onClickVerify.bind(this);

         this.state={
            collapse: false,
            showError: false,
            loading: false,
            logged_in:true,
            access_token:"",
            user_details:{},
            authentication_error: false,
            valid_anumber:false,
            valid_password: false,
            valid_cpassword: false,
            validation_message:"",
            error_message:"",
            anumber_error_message:"Admission number required",
            password_error_message: "Password required",
            cpassword_error_message: "Password confirmation required",
            display_anumber_error:false,
            display_password_error:false,
            display_cpassword_error:false,
            anumber: "",
            password: "",
            queried_api: false,
            api_error: true,
            cpassword: ""

         }
      }


    onClickVerify() {

      let url = this.props.location.search;
      let params = queryString.parse(url);

      let token = params.token;


        if(token)
        {
                this.setState({loading:true});
                const _this = this;
                const url = this.props.base_url +"/staff/verify_account"

                superagent
                .post(url)
                .send({token:token})
                .set('Accept', 'application/json')
                .set('Content-Type', 'application/json')
                .then(function(res){
                    //res.body, res.headers, res.status
                    const error = res.body.error;
                    console.log("Response", res.body);

                    _this.setState({loading:false, queried_api: true, api_error:error, error_message:res.body.message});


                })
                .catch(function(err){

                    const error_response_message = err +".\n\n Please contact system admin.";
                    _this.setState({loading:false,queried_api: true, api_error:true, error_message:error_response_message});
                });


        }

        else
        {
            this.setState({error:true, error_message:"Invalid URL"});

        }
      }



      renderLoadingProgress()
      {
          if(this.state.loading)
          {
              return(
                <div className="loading-progress">
                <div >
                    Loading, Please wait......
                    <ReactLoading className="loading-progress" type="spinningBubbles" color="#000" height="40"  />
                </div>
            </div>

              );
          }
          else{
              return null;
          }
      }




      renderErrorMessage()
      {
          if(this.state.error && !this.state.loading)
          {
              return(
                <div className="loading-progress">
                    <div className="error-message">
                        <p color="red">{this.state.error_message}</p>
                    </div>
                </div>
              );
          }
          else
          {
            return null;
          }

      }

      renderMessage()
      {
          if(this.state.queried_api)
          {
            if(this.state.api_error)
            {
              return(
                <p className="text-center error-message">{this.state.error_message}</p>
              );
            }
            else {
              return(
                <p className="text-center error-message">{this.state.error_message}</p>
              );
            }

          }
          else
          {
            return(
              <p className="text-center">Hi, please click the button below to verify account</p>
            );
          }

      }

      renderButton()
      {
        const _this = this;
          if(this.state.queried_api && !this.state.api_error)
          {
              return(
                <Link to = "/staff">
                    <button type="submit" className="btn btn-green">Login<div className="ripple-container"></div></button>
                </Link>
              );

          }
          else
          {
            return(
              <button type="submit" onClick={_this.onClickVerify.bind(_this)} onTap={_this.onClickVerify.bind(_this)} disabled={this.state.loading}  className="btn btn-green">Verify Account<div className="ripple-container"></div></button>
            );
          }

      }




  render() {

    const _this = this;

    return (

        <form className="form login-form" method="" action="">

                  <div className="card card-login">


                    <div margin-top="-60px" className="card-header-login card-header card-header-rose text-center ">
                        <div style={{top:0}} className="cont-center">
                            <Link  to="/"><img src="/img/logotuc.png" alt="logo" height="120"/></Link>
                        </div>

                        <h4 className="card-title">Verify Account</h4>
                        {this.renderLoadingProgress()}
                    </div>
                    <div className="card-body ">
                      {this.renderMessage()}

                    </div>
                    <div className="card-footer justify-content-center">
                      {this.renderButton()}
                    </div>


                  </div>
        </form>



    );
  }
}

export default ConfirmAccount;
